export default __webpack_public_path__ + "static/media/notification.d6a24e69.bin";